module.exports = __webpack_public_path__ + "82b9f472a3e9d64217f1000aea6095d9.MP3";